<template>
  <CalendarIconSvg />
</template>
<script>
import CalendarIconSvg from '@/assets/images/common/icons/calendar.svg?inline';

export default {
  name: 'CalendarIcon',
  components: {
    CalendarIconSvg,
  },
};
</script>
<style lang="stylus" scoped>
 svg path {
  stroke: currentColor;
 }
</style>
